export const GODMODEMANAGEROLES = 'GODMODEMANAGEROLES'